<template>
    <div>
        <Project  :client="client"
                  :product="product"
                  :tasks="tasks"
        />
        <transition appear name="slide-bot">
            <section class="grid-section" id="project-intro">
                <a href="#" v-scroll-to="'#project-content'" class="scroll-arrow">
                    <svg width="10px" height="72px" viewBox="0 0 10 72" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="arrow-down" fill-rule="nonzero">
                                <polygon id="arrow-copy" transform="translate(4.535534, 36.000347) rotate(-270.000000) translate(-4.535534, -36.000347) " points="38.6565072 36.4648132 -31.464119 36.4648132 -31.464119 35.4648132 38.5854393 35.4648132 35.2925461 32.17192 35.9996529 31.4648132 40.5351868 36.0003471 35.9996529 40.535881 35.2925461 39.8287743"></polygon>
                            </g>
                        </g>
                    </svg>
                </a>
                <img id="intro-content" src="@/assets/img/mille/mille_branding.jpg" />
            </section>
        </transition>
        <section class="grid-section" id="project-content">
            <img src="@/assets/img/mille/millemedia-desktop.jpg" />
        </section>
    </div>
</template>

<script>
    import Project from "@/components/Project.vue";

    export default {
        name: "Millemedia",
        components: {
            Project
        },
        data () {
            return {
                client: "Millemedia",
                product: "Rebrand 2014",
                tasks: {
                    task1: "Corporate Identity",
                    task2: "UX Design",
                    task3: "Photography"
                }
            }
        }
    };
</script>

<style scoped>
    #project-intro
    {
        margin-bottom: 0;
        background-color: rgba(63,63,63,1);
    }

    #project-intro #intro-content
    {
        grid-column: 2 / 6;
        grid-row: 2 / 7;
        height: 75vh;
        justify-self: center;
    }

    .scroll-arrow {
        grid-column: 1 / 2;
        grid-row: 5 / 6;
        padding-right: 20px;
        padding-left: 20px;
        justify-self: right;
        align-self: end;
    }

    #project-intro .scroll-arrow g {
        fill: rgb(248,97,91);
    }

    #project-content {
        height: auto;
        background-color: rgba(63,63,63,1);
        padding-bottom: 20vh;
        padding-top: 20vh;
        margin-bottom: 0;
    }


    #project-content img {
        grid-column: 2 / 6;
        grid-row: 1 / 7;
        width: 100%;
        filter: drop-shadow(0 0.5rem 1.5rem rgba(0,0,0,0.25));
    }
</style>
